// frontend/src/lib/sentry.js
// Initialisation Sentry côté React. Doit être appelé AVANT le render de l'app
// pour capturer les erreurs au boot.
// Le DSN est exposé côté client via VITE_SENTRY_DSN_FRONTEND (Vite exige préfixe VITE_).

import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN_FRONTEND;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // 10% de samples pour le free-tier (5K events/mois).
    tracesSampleRate: 0.1,
    // Pas de session replay par défaut (free-tier limité).
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Filtrer les erreurs réseau standard (4xx auth) qui ne sont pas des bugs.
    beforeSend(event, hint) {
      const err = hint?.originalException;
      const status = err?.response?.status;
      if (status === 401 || status === 403) return null;
      return event;
    },
  });
  console.log('[sentry] frontend initialisé');
}

export default Sentry;
